import getUnitMoveCostOntoPositionEntityStack from '../../entity/getUnitMoveCostOntoPositionEntityStack'
import type { Entity } from '../../entity/index'
import createLazyReadOnlyGridXY from '../createLazyReadOnlyGridXY'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'
import getGridIndexListItemByXYOrThrow from '../GridIndex/getGridIndexListItemOrThrow'

type MoveCostOrNull = number | null

// let allowances = 2

export default function createLazyMovementCostGridV1(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
) {
  // console.log('createLazyMovementCostGridV1', unit.id)
  // if (allowances-- === 0) {
  //   throw new Error('here')
  // }

  const lazyCostGrid = createLazyReadOnlyGridXY<MoveCostOrNull>(
    gridWidth,
    gridHeight,
    function costGridGetter(x: number, y: number): MoveCostOrNull {
      const positionStack = getGridIndexListItemByXYOrThrow(gridWidth, gridHeight, grid, x, y)
      if (positionStack) {
        return getUnitMoveCostOntoPositionEntityStack(unit, positionStack)
      }
      return null
    }
  )
  return lazyCostGrid
}
